import formHelpers from './FormHelpers';
import { validatePhases, checkForErrors } from './Validation';

const phaseHelpers = {};


//To use this helper function, the create method for each container must be performCreateOrUpdate
phaseHelpers.handleNextClick = (activeSection, currentPhase, finishChar, context) => {
    let nextSection = (parseInt(activeSection, 10) + 1).toString();
    let prevFinish = (parseInt(finishChar, 10) - 1).toString();
    let nextPhase = 'phase' + nextSection + 'Fields';
    if (nextSection === finishChar) {
      context.performCreateOrUpdate(currentPhase);
    } else {
      new Promise((resolve, reject) => {
        context.setState({
          [currentPhase]: formHelpers.blurphase(context.state[currentPhase])
        })
        resolve();
      }).then(() => {
        if (checkForErrors(context.state[currentPhase]) === false) {
          context.setState({
            activeSection: nextSection,
            buttonText: nextSection === prevFinish ? 'Finish' : 'Next',
            currentPhase: nextPhase
          })
        } else {
          context.setState({
            [currentPhase]: validatePhases(context.state[currentPhase])
          })
        }
      })
    }
}

phaseHelpers.handleBackClick = (activeSection, currentPhase, context) => {
  let nextSection = (parseInt(activeSection, 10) - 1).toString();
  let nextPhase = 'phase' + nextSection + 'Fields';
  if (nextSection > 0) {
    context.setState({
      activeSection: nextSection,
      buttonText: 'Next',
      currentPhase: nextPhase,
    });
  }
}

export default phaseHelpers;



/** WEBPACK FOOTER **
 ** ./src/helpers/PhaseHelpers.js
 **/